export const capitalizeTokens = (value: string) => `${value}`.split(' ').map((token) => `${(token?.[0] || '').toUpperCase()}${String(token.slice(1) || '').toLowerCase()}`).join(' ')

export default capitalizeTokens
